export default __webpack_public_path__ + "static/media/Copenhagen-Zoo-logo.3f568df4.png";